import script from "./editBali.vue?vue&type=script&setup=true&lang=js"
export * from "./editBali.vue?vue&type=script&setup=true&lang=js"

import "./editBali.vue?vue&type=style&index=0&id=d36d4466&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d36d4466"]])

export default __exports__